import { axiosInstance } from './base'

export const login = async (username, password) => {
  const res = await axiosInstance({
    method: 'POST',
    url: '/user/login',
    data: { username, password },
  })

  return res.data
}

export const getUserList = async () => {
  const res = await axiosInstance({
    method: 'GET',
    url: '/user/list',
  })

  return res.data
}

export const getUserRole = async () => {
  const res = await axiosInstance({
    method: 'POST',
    url: '/user/tier',
  })

  return res.data
}

export const getUser = async (data) => {
  const res = await axiosInstance({
    method: 'POST',
    url: `/user/tier`,
    data: data,
  })

  return res.data
}

export const createUser = async (data) => {
  const res = await axiosInstance({
    method: 'POST',
    url: '/user/create',
    data: data,
  })

  return res.data
}

export const updateUser = async (data) => {
  const res = await axiosInstance({
    method: 'POST',
    url: '/user/update',
    data: data,
  })

  return res.data
}

export const updateUserCerts = async (data) => {
  const res = await axiosInstance({
    method: 'POST',
    url: '/user/update_certificates',
    data: data,
  })

  return res.data
}

export const deleteUser = async (data) => {
  const res = await axiosInstance({
    method: 'POST',
    url: `/user/delete`,
    data: data,
  })

  return res.data
}

export const getUserInfo = async () => {
  const res = await axiosInstance({
    method: 'GET',
    url: '/user/me'
  })

  return res.data
}
